import { Action } from 'redux';

import { isActionFactory } from '~src/bootstrap/redux/actions/isActionFactory';
import { IBroadcastableItemInfo } from '~src/spacesPlatform/models/resourceInfoParts';

import { BroadcastViewCreated, BroadcastViewDeleted, CreateBroadcastView, DeleteBroadcastView, GetBroadcastDetail, UpdateBroadcastView } from '../../bootstrap/redux/actions/AppActionTypes';
import { IBroadcastDetail } from '../models/BroadcastModels';


export interface CreateBroadcastViewAction extends Action {
    item: IBroadcastableItemInfo;
}

export function createBroadcastView(item: IBroadcastableItemInfo): CreateBroadcastViewAction {
    return {
        type: CreateBroadcastView,
        item,
    };
}

export const isCreateBroadcastViewAction = isActionFactory<CreateBroadcastViewAction>(CreateBroadcastView);

export interface BroadcastViewCreatedAction extends Action {
}

export function broadcastViewCreated(): BroadcastViewCreatedAction {
    return {
        type: BroadcastViewCreated,
    };
}

export const isBroadcastViewCreatedAction = isActionFactory<BroadcastViewCreatedAction>(BroadcastViewCreated);

export interface DeleteBroadcastViewAction extends Action {
    item: IBroadcastableItemInfo;
}

export function deleteBroadcastView(item: IBroadcastableItemInfo): DeleteBroadcastViewAction {
    return {
        type: DeleteBroadcastView,
        item,
    };
}

export interface BroadcastViewDeletedAction extends Action {
}

export function broadcastViewDeleted(): BroadcastViewDeletedAction {
    return {
        type: BroadcastViewDeleted,
    };
}

export const isBroadcastViewDeletedAction = isActionFactory<BroadcastViewDeletedAction>(BroadcastViewDeleted);

export interface UpdateBroadcastViewAction extends Action {
    item?: IBroadcastDetail;
}

export function updateBroadcastView(item?: IBroadcastDetail): UpdateBroadcastViewAction {
    return {
        type: UpdateBroadcastView,
        item,
    };
}

export const isUpdateBroadcastViewAction = isActionFactory<UpdateBroadcastViewAction>(UpdateBroadcastView);

export interface GetBroadcastDetailAction extends Action {
    item: IBroadcastableItemInfo;
}

export function getBroadcastDetail(item: IBroadcastableItemInfo): GetBroadcastDetailAction {
    return {
        type: GetBroadcastDetail,
        item,
    };
}

export const isGetBroadcastDetailAction = isActionFactory<GetBroadcastDetailAction>(GetBroadcastDetail);

export interface GetBroadcastDetailFailedAction extends Action { }
